import MemberProfilePanel from "./panels/MemberProfilePanel";


const tabRoutes = [
  {
    name: "24X7 Member Profile",
    path: "/member-profile",
    component: <MemberProfilePanel />
  }
  // ,{
  //   name: "Member Home",
  //   path: "/member-home",
  //   component: <h1>Member Home Tab</h1>,
  // },
  // {
  //   name: "Family Members",
  //   path: "/family-members",
  //   component: <h1>Family Members Tab</h1>,
  // },
  // {
  //   name: "LifeStyle Membership",
  //   path: "/lifeStyle-membership",
  //   component: <h1>LifeStyle Membership Tab</h1>,
  // },
  // {
  //   name: "LifeStyle Activities",
  //   path: "/lifeStyle-activities",
  //   component: <h1>LifeStyle Activities Tab</h1>,
  // }
];

export default tabRoutes;

